import { render, staticRenderFns } from "./PacsFrame.vue?vue&type=template&id=96882096"
import script from "./PacsFrame.vue?vue&type=script&lang=js"
export * from "./PacsFrame.vue?vue&type=script&lang=js"
import style0 from "./PacsFrame.vue?vue&type=style&index=0&id=96882096&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports